import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { Navbar } from '../component/shared/Navbar'
import { ClaimTable } from '../component/staff-benefit-claim/ClaimTable'
import { Helmet } from 'react-helmet-async'
import { PageContainer } from '../component/styled/PageContainer'

export const StaffBenefitClaimPanelScreen = () => {
  return (
    <PageContainer>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Staff Benefit Claims</title>
      </Helmet>
      <Navbar />
      <Box display={{ xs: 'block', md: 'flex' }}>
        <Box overflow='hidden' width='100%' sx={{ p: { xs: 1 } }} mb={{ xs: 2, md: 10 }}>
          <Box display='flex' my={3} justifyContent='space-between'>
            <Typography variant='h1'>Staff Benefit Claims</Typography>
            <Button variant='outlined' component='a' href='/user-staff-benefit'>
              Back
            </Button>
          </Box>
          <ClaimTable />
        </Box>
      </Box>
    </PageContainer>
  )
}
